import { useForm } from 'react-hook-form';
import { useState } from 'react';
import { FormationService } from '../../../../services/formationService';
import logger from '../../../../utils/logger';


export const useAppSubmitForm = (id, radioOption) => {
    const [message, setMessage] = useState(null)
    const [response, setResponse] = useState(null)
    const { register, handleSubmit, formState: { errors }, setValue } = useForm({
        mode: "onBlur",
        defaultValues: {
            // Valor por defecto de los cupos en la formacion
            maxQuota: 0,
        },
    })

    //console.log('radioOption: ', radioOption)

    const onSubmit = async (data) => {
        try {
            console.log('data controler es: ', data)


            const result = await FormationService.createFormation(data)


            // const result = null
            setResponse(result)

            //console.log('respuesta de la api', result)
            setMessage(result.message)



        } catch (error) {
            // console.error('El error del controlador fue: ',error);
            // alert(`${error.message}`)
            // throw error

            logger.error('error al crear formacion: ', error)

            // const status = error.response?.status || 'Error de red'
            const message = error.response?.data?.message || error.message

            setMessage(message)
            setResponse(error)
        }
    }


    return { register, handleSubmit, onSubmit, setValue, message, errors, response }
}